import { render, staticRenderFns } from "./vue-clap-button.vue?vue&type=template&id=497c6f7e&scoped=true&"
import script from "./vue-clap-button.vue?vue&type=script&lang=js&"
export * from "./vue-clap-button.vue?vue&type=script&lang=js&"
import style0 from "./vue-clap-button.vue?vue&type=style&index=0&id=497c6f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497c6f7e",
  null
  
)

export default component.exports